import { useEffect, useState } from "react";
import { subscribeMutationLoading } from "../../services/mutationLoader";

export default function MutationActionLoader() {
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeMutationLoading(setVisible), []);

  if (!visible) return null;

  return (
    <div className="mutation-loader-screen" role="status" aria-live="polite" aria-label="Processando alteração">
      <div className="mutation-loader-card">
        <div className="mutation-loader-glow" aria-hidden="true" />
        <div className="loader-docs-3d mutation-docs" aria-hidden="true">
          <span className="loader-doc doc-a" />
          <span className="loader-doc doc-b" />
          <span className="loader-doc doc-c" />
          <span className="loader-stamp">OK</span>
        </div>
        <div className="mutation-loader-title">Processando alteração</div>
        <div className="mutation-loader-subtitle">Salvando dados com segurança...</div>
      </div>
    </div>
  );
}

